<template>
  <el-upload
    ref="upload"
    action=""
    :limit="1"
    :accept="accept"
    :file-list="fileList"
    :list-type="type"
    :auto-upload="false"
    :on-change="handelChange"
    :on-remove="handelRemove"
    :before-upload="beforeUpload"
    :http-request="fnUploadRequest"
  >
    <el-button slot="trigger" size="small" type="primary" @click="selectFile">选择文件</el-button>
    <!--<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">{{ btnText }}</el-button>-->
    <div v-if="tip" slot="tip" class="el-upload__tip">只能上传{{ accept }}格式文件</div>
  </el-upload>
</template>
<script>
import OSS from 'ali-oss'
import axios from 'axios'
import { getToken } from '@/utils/token'

export default {
  name: 'Upload', // 只适用于单文件上传，多文件上传因为我写组件时候用不到，就没去操心-。-
  props: {
    accept: {
      type: String,
      default: '' // 选择文件类型，例如image/jpeg,image/gif,image/png，更多：https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#Unique_file_type_specifiers
    },
    size: {
      type: Number,
      default: 10 // 文件大小，单位是M
    },
    folder: {
      type: String,
      default: ''
    },
    region: {
      type: String,
      default: 'oss-cn-shenzhen' // oss region
    },
    accessKeyId: {
      type: String,
      default: '' // oss accessKeyId
    },
    accessKeySecret: {
      type: String,
      default: '' // oss accessKeySecret
    },
    bucket: {
      type: String,
      default: 'wondfo-iot' // oss bucket
    },
    type: {
      type: String, // text/picture/picture-card
      default: 'text'
    }
  },
  data() {
    return {
      fileList: [],
      tempCheckpoint: null,
      pause: false,
      temPercent: 0,
      btnText: '上传到OSS',
      fileName: null,
      sts: null
    }
  },
  computed: {
    tip() {
      return this.accept.length > 0
    }
  },
  created() {
    this.getToken()
  },
  methods: {
    getToken() {
      axios({
        method: 'get',
        headers: { 'Authority': getToken() },
        url: process.env.VUE_APP_USER_API + '/user/sts'
      }).then(res => {
        console.log('sts')
        console.log(res)
        this.sts = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    selectFile() {
      this.fileList = []
      this.$refs.upload.clearFiles()
      this.$emit('update:file-list', [])
      this.tempCheckpoint = null
      this.pause = false
      this.btnText = '上传到OSS'
    },
    handelChange(file, fileList) {
      console.log(fileList)
      this.fileList = fileList
      this.$emit('update:file-list', fileList)
    },
    handelRemove(file, fileList) {
      this.fileList = fileList
      this.$emit('update:file-list', fileList)
    },
    submitUpload(fileName) {
      this.fileName = fileName
      // console.log(this.$refs.upload.uploadFiles)
      const files = this.$refs.upload.uploadFiles
      // status: ready,uploading,success,fail
      if (files.length > 0 && this.pause) {
        files[0].status = 'ready'
      }
      this.$refs.upload.submit()
    },
    beforeUpload(file) {
      let isType = true
      const point = file.name.lastIndexOf('.')
      const suffix = file.name.substr(point)
      if (this.accept) {
        const types = this.accept.split(',')
        isType = !(types.indexOf(suffix) < 0)
      }
      const fileSize = file.size
      const isSize = fileSize / 1024 / 1024 < this.size
      if (!isType) {
        this.$message.error('文件格式要求是：' + this.accept)
      }
      if (!isSize) {
        this.$message.error('文件大小不能超过：' + this.size + 'M')
      }
      return isType && isSize
    },
    fnUploadRequest(option) {
      // console.log(option)
      const ossConfig = {
        region: this.region,
        accessKeyId: this.sts.accessKeyId,
        accessKeySecret: this.sts.accessKeySecret,
        stsToken: this.sts.securityToken,
        bucket: this.bucket
      }
      // console.log(ossConfig)
      const client = new OSS(ossConfig)
      this.client = client
      const file = option.file
      let fileName
      const date = new Date().getTime()
      const point = file.name.lastIndexOf('.')
      const suffix = file.name.substr(point)
      // console.log(this.fileName)
      if (this.fileName) {
        fileName = `${this.fileName}_${date}${suffix}`
      } else {
        const name = file.name.substr(0, point)
        fileName = `${name}_${date}${suffix}`
      }
      fileName = process.env.VUE_APP_ENV + '/' + fileName
      // const fileName = option.file.name
      console.log('filename is ' + fileName)
      console.log(fileName)
      const _this = this
      if (this.pause) {
        const e = {}
        e.percent = this.temPercent * 100
        option.onProgress(e)
      }
      async function multipartUpload() {
        try {
          const result = await client.multipartUpload(fileName, file, {
            progress: async function(p, checkpoint) {
              // 断点记录点。 浏览器重启后无法直接继续上传，需用户手动触发进行设置。
              _this.tempCheckpoint = checkpoint
              const e = {}
              e.percent = p * 100
              option.onProgress(e)
              _this.temPercent = p
              console.log(p)
            },
            checkpoint: _this.tempCheckpoint
          })
          // console.log(result)
          if (result.res.statusCode === 200) {
            _this.pause = false
            _this.tempCheckpoint = null
            _this.btnText = '上传到OSS'
            option.onSuccess(result)
            // const url = client.signatureUrl(fileName, { expires: 3600 })
            // console.log(url)
          } else {
            // option.onError('上传失败')
            _this.$message({
              message: '上传失败',
              type: 'error',
              duration: 2 * 1000
            })
            _this.pause = true
            _this.btnText = '继续上传到OSS'
          }
        } catch (e) {
          // option.onError('上传失败')
          _this.$message({
            message: '上传失败',
            type: 'error',
            duration: 2 * 1000
          })
          _this.pause = true
          _this.btnText = '继续上传到OSS'
          console.log(e)
        }
      }
      multipartUpload()
    }
    /* handleSuccess(response, file, fileList) {
      // console.log(fileList)
      this.fileList = fileList
      this.$emit('update:file-list', fileList)
    },
    handleRemove(response, file, fileList) {
      // console.log(fileList)
      this.fileList = fileList
      this.$emit('update:file-list', fileList)
    }*/
  }
}
</script>

<style scoped>

</style>
